import request from './request.js';
import {requestbody} from './request.js'
//开票数据台账导入
export async function openInvoice_importExcel (params = {}) {
	return await request('/open-invoice-account/file/upload', 'post', params)
}
//开票数据台账分页查询
export async function openInvoice_page (params = {}) {
	return await request('/open-invoice-account/page', 'get', params)
}
//开票数据台账删除
export async function openInvoice_del (params = {}) {
	return await request('/open-invoice-account/delete', 'post', params)
}